import {
  Timeline,
  TimelineConnector,
  TimelineContent,
  TimelineDot,
  TimelineItem,
  TimelineSeparator,
} from "@mui/lab";
import { Icon, Typography } from "@mui/material";
import { useContext, useEffect, useMemo, useState } from "react";
import { useScreenClass } from "react-grid-system";
import styled from "styled-components";
import theme from "../styles/theme";
import { CustomBlock, StyledImg } from "./CompetenciesList";
import CompetencyModal from "./CompetencyModal";
import FlexBox, { FlexGrow } from "./FlexBox";
import { ClickableIcon } from "./Icon";
import TabGroup, { TabItem } from "./TabGroup";
import { StyledText, TextSize, TextStatus } from "./Text";
import defaultImg from "../assets/DefaultCardImage.png";
import Button from "./Button";
import Status from "../types/enum/Status";
import SnackBar from "./SnackBar";
import axios from "axios";
import { UserContext } from "../context/UserContext";
import { SemesterContext } from "../context/SemesterContext";

const Header = styled.h4`
  font-family: Montserrat;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 28px;
  letter-spacing: 0px;
  text-align: left;
`;
const CustomFlex = styled(FlexBox)`
  padding: 20px 0;
  align-items: center;
  border-bottom: 1px solid #3c406c;
`;
const CustomFlexPlain = styled(FlexBox)`
  padding: 20px 0;
  align-items: flex-start;
`;
const CustomGrowPlain = styled(FlexGrow)`
  min-width: 150px;
  flex-grow: 0;
`;
const CustomGrow = styled(FlexGrow)`
  flex-grow: 0;
  height: 100%;
  border-right: 1px solid #3c406c;
`;
const Label = styled.h5`
  font-family: Montserrat;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
  letter-spacing: 0px;
  text-align: left;
`;
const LabelData = styled(StyledText)`
  font-family: Montserrat;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: 0.20000000298023224px;
  text-align: left;
  color: #e6e6e6;
  vertical-align: text-top;
`;
const Ul = styled.ul`
  color: #d0d0d0;
  padding-inline-start: 16px;
  margin-block-start: 0;
  margin-block-end: 0;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0px;
  text-align: left;
`;
type CompetencyDetailModalProps = {
  selectedStudent?: string;
  isOpen?: boolean;
  data: any;
  setOpen: (x: boolean) => void;
  fetchParent: () => void;
};
const CompetencyDetailModal = ({
  selectedStudent,
  isOpen,
  setOpen,
  data,
  fetchParent,
}: CompetencyDetailModalProps): JSX.Element => {
  const [tab, setTab] = useState(0);
  const [isSnackbarOpen, setIsSnackbarOpen] = useState<boolean>(false);
  const [messageType, setMessageType] =
    useState<"error" | "success" | "warning" | "info">("error");
  const [message, setMessage] = useState<string>("");
  const [messageHeader, setMessageHeader] = useState<string>("");
  const screenClass = useScreenClass();
  const currentUser = useContext(UserContext).user;
  const semesterContext = useContext(SemesterContext);
  const isMobile = useMemo(
    () => ["xs", "sm"].includes(screenClass),
    [screenClass]
  );
  // const restore = () => {
  //   setMessage('Restored competency successfully!');
  //   setIsSnackbarOpen(true);
  // };
  // const restore = () => {
  //   axios
  //     .post("/card/restore", {
  //       student_id: selectedStudent,
  //       card_id: data.id,
  //       semester_name: semesterContext.selectedSemester.label,
  //     })
  //     .then((res) => {
  //       setMessage("Restored card successfully");
  //       if (res.data.card) {
  //         setMessageType("success");
  //         setMessageHeader("Success!");
  //         fetchParent();
  //       } else {
  //         setMessageType("error");
  //         setMessageHeader("Error!");
  //       }
  //       setIsSnackbarOpen(true);
  //       setOpen(false);
  //     })
  //     .catch((err) => {
  //       setMessageType("error");
  //       setMessageHeader("Error!");
  //       setMessage(err.response.data.error);
  //       setIsSnackbarOpen(true);
  //     });
  // };

  useEffect(() => {
    getCompetencyDetail();
  }, [data]);

  const [competencyDetail, setCompetencyDetail] = useState<any>();
  const getCompetencyDetail = () => {
    axios
      .get(
        `/competency/detail?competency_code=${data?.competency_code}&university_code=${data?.university_code}&curriculum_version=${data?.curriculum_version}&semester_name=${data?.semester_name}`
      )
      .then((res) => setCompetencyDetail(res.data.competency))
      .catch(() => {
        setCompetencyDetail(null);
      });
  };
  return (
    <>
      <SnackBar
        isOpen={isSnackbarOpen}
        setOpen={setIsSnackbarOpen}
        message={message}
        type={messageType}
        header={messageHeader}
      />
      <CompetencyModal
        customStyle={{
          overlay: {
            zIndex: "1005",
          },
          content: {
            inset: `0px 0px 0px ${isMobile ? "0px" : theme.sidebarWidth}`,
            maxWidth: "100%",
            background: "#0B0C1F",
          },
        }}
        isOpen={isOpen || false}
        setOpen={setOpen}
      >
        <CustomFlex>
          <FlexGrow>
            <Header>
              [{data.competency_code}] {data.title}
            </Header>
          </FlexGrow>
          <ClickableIcon
            size={3.125}
            fixedWidth={false}
            name="times"
            onClick={() => setOpen(false)}
          />
        </CustomFlex>
        <CustomFlex>
          <FlexGrow>
            <TabGroup
              style={{ borderBottom: "none", padding: "0", margin: "0" }}
            >
              <TabItem active={tab === 0} onClick={() => setTab(0)}>
                Competency Details
              </TabItem>
              <TabItem active={tab === 1} onClick={() => setTab(1)}>
                History Events
              </TabItem>
            </TabGroup>
          </FlexGrow>
        </CustomFlex>
        <CustomFlex
          className="visible-scrollbar"
          style={{
            borderBottom: "none",
            height: "75vh",
            alignItems: "flex-start",
            overflowY: "scroll",
          }}
        >
          {!isMobile && (
            <CustomGrow style={{ textAlign: "center" }}>
              <CustomBlock
                style={{ marginRight: "24px" }}
                backgroundColor={data.graphics.iconbg}
              >
                <div style={{ padding: "5px 0px", fontWeight: "bold" }}>
                  {data.competency_code}
                </div>
                <StyledImg
                  src={
                    data.graphics.imgurl
                      ? process.env.REACT_APP_IMG_URL + data.graphics.imgurl
                      : defaultImg
                  }
                  alt=""
                />
                <Icon
                  sx={{
                    color: "white",
                    padding: "6px",
                    background: data.graphics.iconbg,
                    borderRadius: "100px",
                    fontSize: "27px",
                    position: "absolute",
                    bottom: "105px",
                    right: "98px",
                    boxShadow: data.graphics.iconshadow,
                  }}
                >
                  {data.graphics.icon}
                </Icon>
                <StyledText fontWeight="700">{data.title}</StyledText>
              </CustomBlock>
              {/* {data.status === "Archived" && (
                <Button
                  onClick={() => {
                    restore();
                  }}
                  style={{ marginRight: "24px" }}
                  status={Status.blue}
                >
                  <Icon>restore</Icon>
                  Restore
                </Button>
              )} */}
            </CustomGrow>
          )}
          <FlexGrow>
            {tab === 0 && (
              <>
                <CustomFlexPlain>
                  <CustomGrowPlain>
                    <Label>Pillars</Label>
                  </CustomGrowPlain>
                  <FlexGrow>
                    <Icon
                      sx={{
                        color: "rgba(0, 0, 0, 0.6)",
                        mr: 1,
                        padding: "4px",
                        background: data.graphics.iconbg,
                        boxShadow: data.graphics.iconshadow,
                        borderRadius: "100px",
                        fontSize: "16px",
                        verticalAlign: "sub",
                      }}
                    >
                      {data.graphics.icon}
                    </Icon>
                    <LabelData>{data.pillar_title}</LabelData>
                  </FlexGrow>
                </CustomFlexPlain>
                <CustomFlexPlain>
                  <CustomGrowPlain>
                    <Label>Version</Label>
                  </CustomGrowPlain>
                  <FlexGrow>
                    <StyledText style={{ color: "#d0d0d0" }}>
                      {competencyDetail?.display_version}
                    </StyledText>
                  </FlexGrow>
                </CustomFlexPlain>
                <CustomFlexPlain>
                  <CustomGrowPlain>
                    <Label>Version Status</Label>
                  </CustomGrowPlain>
                  <FlexGrow>
                    <StyledText style={{ color: "#d0d0d0" }}>
                      {competencyDetail?.version_status}
                    </StyledText>
                  </FlexGrow>
                </CustomFlexPlain>
                <CustomFlexPlain>
                  <CustomGrowPlain>
                    <Label>Domain</Label>
                  </CustomGrowPlain>
                  <FlexGrow>
                    <StyledText style={{ color: "#d0d0d0" }}>
                      {data.subdomain_title}
                    </StyledText>
                  </FlexGrow>
                </CustomFlexPlain>
                <CustomFlexPlain>
                  <CustomGrowPlain>
                    <Label>Credits</Label>
                  </CustomGrowPlain>
                  <FlexGrow>
                    <StyledText
                      style={{ color: "#d0d0d0", paddingRight: "5px" }}
                    >
                      {data.credits}
                    </StyledText>
                    {data.required && (
                      <StyledText style={{ color: "#d0d0d0" }}>
                        -- REQUIRED
                      </StyledText>
                    )}
                  </FlexGrow>
                </CustomFlexPlain>
                <CustomFlexPlain>
                  <CustomGrowPlain>
                    <Label>Status</Label>
                  </CustomGrowPlain>
                  <FlexGrow>
                    <StyledText style={{ color: "#d0d0d0" }}>
                      {data.status} {(data.mastery_level_title) && (
                        <>- {data.mastery_level_title}</>
                      )}
                    </StyledText>
                  </FlexGrow>
                </CustomFlexPlain>
                <CustomFlexPlain>
                  <CustomGrowPlain>
                    <Label>SKILLS</Label>
                  </CustomGrowPlain>
                  <FlexGrow>
                    <Ul>
                      {data.skills &&
                        data.skills.map((skill: any) => (
                          <li>
                            <div>
                              <StyledText fontWeight="bold">
                                [{skill.skill_code}]
                              </StyledText>
                            </div>
                            {skill.assessment?.title}
                            {skill.completed &&
                              ` (Completed - ${skill.assessment.result})`}
                            <Ul>
                              <li>
                                <div>
                                  <StyledText
                                    status={TextStatus.warning}
                                    style={{ fontWeight: "bold" }}
                                  >
                                    {skill?.assessment?.title}
                                  </StyledText>
                                </div>
                                <StyledText status={TextStatus.muted}>
                                  {skill?.assessment?.description}
                                </StyledText>
                              </li>
                            </Ul>
                          </li>
                        ))}
                    </Ul>
                  </FlexGrow>
                </CustomFlexPlain>
                {data.description && (
                  <CustomFlexPlain>
                    <CustomGrowPlain>
                      <Label>Description:</Label>
                    </CustomGrowPlain>
                    <FlexGrow>
                      <StyledText
                        textSize={TextSize.sidebar}
                        status={TextStatus.muted}
                      >
                        {data.description}
                      </StyledText>
                    </FlexGrow>
                  </CustomFlexPlain>
                )}
              </>
            )}
            {tab === 1 && (
              <Timeline>
                {data.card_history_events.map((history: any) => (
                  <TimelineItem sx={{ ":before": { flex: 0, padding: 0 } }}>
                    <TimelineSeparator>
                      <TimelineDot sx={{ backgroundColor: "#C54B4D" }} />
                      <TimelineConnector sx={{ backgroundColor: "#3C406C" }} />
                    </TimelineSeparator>
                    <TimelineContent>
                      <Typography color={"#9295AA"} component="span">
                        {history.date_time}
                      </Typography>
                      <Typography fontWeight={"bold"}>
                        {history.event_type}
                      </Typography>
                      <Typography fontWeight={"300"}>
                        {history.event_description}
                      </Typography>
                    </TimelineContent>
                  </TimelineItem>
                ))}
              </Timeline>
            )}
          </FlexGrow>
        </CustomFlex>
      </CompetencyModal>
    </>
  );
};

export default CompetencyDetailModal;
